export default {
    main: {
        首页: 'HomePage',
        订单生成中: 'Order generating',
        请稍候: 'Please wait...',
        安全支付: 'Secure Payment',
        订单号: 'OrderID',
        金额: 'Amount',
        支付提示: 'Tips',
        请在: 'please at ',
        秒内: ' seconds ',
        完成: 'finish ',
        支付: 'payment ',
        超时会自动: 'timeout will auto ',
        取消: 'cancel ',
        生成中请稍候: 'Generating',
        剩余时间: 'Time left',
        订单已失效: 'Order expired',
        订单已失效Memo: 'Please place an order again or wait for the payment to arrive !',
        订单异常: 'Order Abnormality',
        发生错误: 'An error occurred',
        订单生成失败: 'Order generation failed',
        暂无可用的订单: 'No orders available',
        订单: 'The order ',
        已支付: 'has been paid ',
        已超时: 'has timed out ',
        生成失败: 'generation failed ',
        已支付Memo: 'Your order has been confirmed to be paid successfully. Please close this page and confirm the receipt of the funds.',
        已超时Memo: 'Your order payment has timed out. Please close this page and place your order again.',
        生成失败Memo: 'Your order generation failed. Please close this page and place the order again.',
    }
}
